<ng-container *transloco="let t; read: 'localDatePicker'">
  <div class="root">
    <div
      #popover="popover"
      skyUiPopover
      [skyUiPopoverContentRef]="popoverTemplate"
      [skyUiPopoverPosition]="{ originX: 'center', overlayX: 'center' }"
      class="selected-day"
    >
      <ng-container *ngIf="!field.readonly">
        <mat-form-field class="form-field">
          <mat-label>{{ field.name }}</mat-label>
          <input
            type="text"
            matInput
            [matDatepicker]="picker"
            [formControl]="fakeControlDate"
            readonly
          />
          <mat-datepicker #picker></mat-datepicker>

          <button matSuffix mat-icon-button aria-label="Clear" type="button">
            <mat-icon>calendar_today</mat-icon>
          </button>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="field?.readonly === true">
        <crm-row>
          <header>{{ field?.name }}</header>
          <main>{{ value | date: 'short' }}</main>
        </crm-row>
      </ng-container>
    </div>

    <ng-template #popoverTemplate>
      <owl-date-time-inline
        #owlPicker
        class="owl-picker"
        [value]="value"
        [min]="dateTimeMin"
        [max]="dateTimeMax"
        [firstDayOfWeek]="1"
        [stepMinute]="15"
      ></owl-date-time-inline>
      <div class="wrap-selected-time">
        {{ t('mskTimeTitle') }}
      </div>

      <ng-container *ngIf="timezone">
        <hr class="line-hr" />

        <div class="wrap-mask-time">
          {{ t('localTimeTitle') }}:
          <div class="msk-date">
            {{ owlPicker.value! | localToTimezone: timezone : 'HH:mm, dd.MM' }}
            {{ timezone | getMskUtc }}
          </div>
        </div>

        <hr class="line-hr" />
      </ng-container>

      <div class="action-panel" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button (click)="close()">
          {{ t('button.cancel') }}
        </button>
        <button class="set-btn" mat-button (click)="setDate(owlPicker.value)">
          {{ t('button.set') }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>
